const parseBlockedKeywords = (value = '') => {
  if (!value || typeof value !== 'string') {
    return []
  }

  return value
    .split(/[\n,，;；|]/)
    .map((keyword) => keyword.trim())
    .filter(Boolean)
}

export const BLOCKED_KEYWORDS = Array.from(
  new Set(parseBlockedKeywords(process.env.VUE_APP_BLOCKED_KEYWORDS))
)

const normalizedBlockedKeywords = BLOCKED_KEYWORDS.map((keyword) =>
  String(keyword || '').toLowerCase().replace(/\s+/g, '')
).filter(Boolean)

function hasBlockedKeyword(text) {
  if (typeof text !== 'string') {
    return false
  }

  const normalizedText = text.toLowerCase().replace(/\s+/g, '')
  return normalizedBlockedKeywords.some((keyword) => normalizedText.includes(keyword))
}

export function resourceHasBlockedKeyword(resource) {
  if (resource === null || resource === undefined) {
    return false
  }

  const stack = [resource]
  const visited = new WeakSet()

  while (stack.length > 0) {
    const current = stack.pop()

    if (typeof current === 'string') {
      if (hasBlockedKeyword(current)) {
        return true
      }
      continue
    }

    if (!current || typeof current !== 'object') {
      continue
    }

    if (visited.has(current)) {
      continue
    }
    visited.add(current)

    if (Array.isArray(current)) {
      current.forEach((item) => stack.push(item))
      continue
    }

    Object.values(current).forEach((value) => stack.push(value))
  }

  return false
}

export function filterBlockedResources(resources = []) {
  if (!Array.isArray(resources)) {
    return []
  }

  return resources.filter((resource) => !resourceHasBlockedKeyword(resource))
}
